import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLocalNetwork = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-local-network';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.36 3.281c-1.702.114-3.264.715-4.407 1.696l-.306.263H3.24v11.52h8v2.48H7.08v1.52h9.84v-1.52h-4.16v-2.48h8V5.24h-3.407l-.306-.264c-.83-.713-2.076-1.309-3.203-1.532a9.8 9.8 0 0 0-2.484-.163m1.472 1.522a6.3 6.3 0 0 1 2.188.627c.616.309.982.585 1.387 1.046l.251.284h2.582v8.48H4.76V6.76h2.582l.251-.284c.405-.461.771-.737 1.387-1.046a6.5 6.5 0 0 1 2.14-.626 10 10 0 0 1 1.712-.001m-1.303 2.478a4.2 4.2 0 0 0-2.591 1.217c-.378.377-.692.805-.632.862.018.018.312.187.652.375l.617.341.098-.148c.253-.383.784-.799 1.237-.968.57-.214 1.35-.256 1.9-.104.308.085.762.312 1.021.512.186.144.476.464.566.626.024.043.176-.028.667-.313.35-.203.642-.375.65-.382.035-.033-.358-.549-.611-.802a4.3 4.3 0 0 0-2.183-1.15 5.4 5.4 0 0 0-1.391-.066M11.24 12v.8h1.52v-1.6h-1.52z"
    })
  }));
});
export default SvgLocalNetwork;